import { ButtonVariant } from '../../../utils/buttonStyles.js';
import { getFieldChevronStyles } from '../Field/FieldStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { Icon } from '../../Icon/Icon.js';
import { Button } from '../../Button/Button.js';
import { IconSize } from '../../Icon/types/size.js';

const RightIcon = _ref => {
  let {
    disabled,
    buttonLabel,
    iconName,
    onClick
  } = _ref;
  return jsx(Button, {
    css: getFieldChevronStyles(disabled),
    "aria-label": buttonLabel,
    disabled: disabled,
    onClick: onClick,
    variant: ButtonVariant.TEXT,
    children: jsx(Icon, {
      size: IconSize.SIZE_MEDIUM,
      name: iconName
    })
  });
};

export { RightIcon };
//# sourceMappingURL=RightIcon.js.map
